export default {
	home: '/',
	terms:  '/terms',
	privacyPolicy:  '/privacypolicy',
	download: '/download',
	gallery: '/gallery'
}